module.exports = __webpack_public_path__ + "static/media/civic-logo-stack_standard.d9ee94c8.svg";